/**
 * @generated SignedSource<<a3e83df740c08623c9e129a1eff2000a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useUserInfoFormIsUsernameAvailableQuery$variables = {
  username: string;
};
export type useUserInfoFormIsUsernameAvailableQuery$data = {
  readonly user: {
    readonly __typename: "ErrUserNotFound";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useUserInfoFormIsUsernameAvailableQuery = {
  response: useUserInfoFormIsUsernameAvailableQuery$data;
  variables: useUserInfoFormIsUsernameAvailableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserInfoFormIsUsernameAvailableQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "userByUsername",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/)
            ],
            "type": "ErrUserNotFound",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserInfoFormIsUsernameAvailableQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "userByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b4ad9b80d92019955abeb74bd733905",
    "id": null,
    "metadata": {},
    "name": "useUserInfoFormIsUsernameAvailableQuery",
    "operationKind": "query",
    "text": "query useUserInfoFormIsUsernameAvailableQuery(\n  $username: String!\n) {\n  user: userByUsername(username: $username) {\n    __typename\n    ... on ErrUserNotFound {\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e779d373952f029b424d8c40d819aa42";

export default node;
